import React, { useEffect, useState } from 'react';
import { Box, Button, Card, CircularProgress, Stack, Typography } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import SEO from '../../components/SEO';
import { userApiClient } from '../../userApiClient';

/** Landing page for Stripe's pass checkout success redirect; also warms the wallet list cache. */
const PassPurchaseSuccessPage: React.FC = () => {
  const { t } = useTranslation();
  const [refreshing, setRefreshing] = useState(true);

  useEffect(() => {
    let cancelled = false;
    userApiClient
      .listWalletPasses()
      .catch(() => undefined)
      .finally(() => {
        if (!cancelled) setRefreshing(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <SEO title={t('passes.purchaseSuccessTitle', 'Pass purchased')} noindex />
      <Box sx={{ maxWidth: 560, mx: 'auto', p: { xs: 2, sm: 4 } }}>
        <Card elevation={3} sx={{ p: { xs: 3, sm: 4 }, textAlign: 'center' }}>
          <Stack spacing={2} alignItems="center">
            <CheckCircleRoundedIcon color="success" sx={{ fontSize: 56 }} />
            <Typography variant="h5" fontWeight={700}>
              {t('passes.purchaseSuccessTitle', 'Pass purchased')}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {t(
                'passes.purchaseSuccessBody',
                'Your pass has been added to your wallet and is ready to use.',
              )}
            </Typography>
            {refreshing && <CircularProgress size={20} />}
            <Button component={RouterLink} to="/user/passes" variant="contained" size="large" sx={{ mt: 1 }}>
              {t('passes.viewMyPasses', 'View my passes')}
            </Button>
          </Stack>
        </Card>
      </Box>
    </>
  );
};

export default PassPurchaseSuccessPage;
